import { Directive, Input, HostListener, Output, EventEmitter, ElementRef } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from '../components/confirmation-dialog.component';

@Directive({
  selector: '[plrConfirmation]'
})
export class ConfirmationDialogDirective {
  @Input('plrConfirmation')
  confirmation: string;

  @Input()
  local: any;

  @Output()
  confirmed: EventEmitter<any> = new EventEmitter();

  constructor(private dialog: MatDialog, private elementRef: ElementRef) {}

  @HostListener('click')
  onClick() {
    if(this.local){
      this.local.elementRef = this.elementRef;
    }
    this.dialog.open(ConfirmationDialogComponent,
      {
        panelClass: 'customized-dialog',
        width: '30vw',
        data: { message: this.confirmation, local: this.local }
      }).afterClosed()
      .subscribe(result => {
        if (result) {
          this.confirmed.emit();
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/common/directives/confirmation-dialog.directive.ts